<template>
  <div class="mass-schedule-fields pa-2 pt-0">
    <v-checkbox
      :input-value="value.useSchedule"
      class="mt-0"
      hide-details
      :label="variant === 'endOnly' ? 'Указать дату сброса изображения' : 'Добавить период действия (дата начала и дата окончания)'"
      @change="onToggleSchedule"
    />
    <v-expand-transition>
      <div v-show="value.useSchedule" class="mass-schedule-fields__expand">
        <template v-if="variant === 'endOnly'">
          <p class="text-caption grey--text text--darken-1 mb-2">
            <strong class="primary--text">Загрузка изображения на домофоны выполняется сразу после отправки.</strong>
            Сброс на стандартное изображение произойдёт в указанные дату и время.
          </p>
          <v-menu
            v-model="menuPeriod"
            :close-on-content-click="false"
            offset-y
            transition="scale-transition"
            :nudge-right="0"
            min-width="0"
            max-height="90vh"
            content-class="mass-schedule-fields__menu-content mass-schedule-fields__menu-content--end-only"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                v-on="on"
                :value="periodText"
                label="Дата и время сброса"
                readonly
                outlined
                dense
                hide-details
                class="mass-schedule-fields__period-input"
                prepend-inner-icon="mdi-calendar-clock"
              />
            </template>
            <div class="mass-schedule-fields__end-only-menu">
              <div class="mass-schedule-fields__end-only-scroll">
                <v-date-picker
                  v-model="singleDate"
                  :min="todayYmd"
                  class="mass-schedule-fields__picker"
                  no-title
                />
                <v-time-picker
                  v-model="resetTime"
                  format="24hr"
                  full-width
                  class="mass-schedule-fields__time-picker"
                />
              </div>
              <div class="mass-schedule-fields__end-only-actions">
                <v-row class="ma-0" no-gutters>
                  <v-col cols="6" class="pr-1">
                    <v-btn
                      outlined
                      color="primary"
                      class="text-none"
                      block
                      :disabled="!singleDate"
                      @click="clearPeriodEndOnly"
                    >
                      Сбросить
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="pl-1">
                    <v-btn
                      outlined
                      color="primary"
                      class="text-none"
                      block
                      :disabled="!canApplyEndOnly"
                      @click="applyPeriodEndOnly"
                    >
                      Выбрать
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-menu>
        </template>
        <template v-else>
          <p class="text-caption grey--text text--darken-1 mb-2">
            Применение функции можно задать заранее: изменения начнутся в выбранные дату и время
            (если указать текущий момент — загрузка произойдет сразу), а по окончании периода звук, текст или изображение на экране вернутся к стандартным значениям.
          </p>
          <v-menu
            v-model="menuPeriod"
            :close-on-content-click="false"
            offset-y
            transition="scale-transition"
            :nudge-right="0"
            min-width="0"
            max-height="90vh"
            content-class="mass-schedule-fields__menu-content mass-schedule-fields__menu-content--range"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                v-on="on"
                :value="periodText"
                label="Период действия"
                readonly
                outlined
                dense
                hide-details
                class="mass-schedule-fields__period-input"
                prepend-inner-icon="mdi-calendar-clock"
              />
            </template>
            <div class="mass-schedule-fields__range-menu">
              <div class="mass-schedule-fields__range-scroll">
                <v-date-picker
                  v-model="dateRange"
                  range
                  :min="todayYmd"
                  class="mass-schedule-fields__picker"
                  no-title
                />
                <div class="mass-schedule-fields__times">
                  <v-menu
                    v-model="menuStartTime"
                    :close-on-content-click="false"
                    offset-y
                    max-width="290"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-bind="attrs"
                        v-on="on"
                        :value="startTime"
                        label="Время начала"
                        readonly
                        outlined
                        dense
                        hide-details
                        prepend-inner-icon="mdi-clock-start"
                      />
                    </template>
                    <v-time-picker
                      v-model="startTime"
                      format="24hr"
                      full-width
                      :min="minStartTime"
                      @click:minute="onStartTimePicked"
                    />
                  </v-menu>
                  <v-menu
                    v-model="menuEndTime"
                    :close-on-content-click="false"
                    offset-y
                    max-width="290"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-bind="attrs"
                        v-on="on"
                        :value="endTime"
                        label="Время окончания"
                        readonly
                        outlined
                        dense
                        hide-details
                        prepend-inner-icon="mdi-clock-end"
                      />
                    </template>
                    <v-time-picker
                      v-model="endTime"
                      format="24hr"
                      full-width
                      @click:minute="menuEndTime = false"
                    />
                  </v-menu>
                </div>
              </div>
              <div class="mass-schedule-fields__range-actions">
                <v-row class="ma-0" no-gutters>
                  <v-col cols="6" class="pr-1">
                    <v-btn
                      outlined
                      color="primary"
                      class="text-none"
                      block
                      :disabled="!dateRange[0]"
                      @click="clearPeriod"
                    >
                      Сбросить
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="pl-1">
                    <v-btn
                      outlined
                      color="primary"
                      class="text-none"
                      block
                      :disabled="!canApplyPeriod"
                      @click="applyPeriod"
                    >
                      Выбрать
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-menu>
        </template>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  name: 'MassScheduleFields',
  props: {
    value: {
      type: Object,
      required: true,
    },
    variant: {
      type: String,
      default: 'range',
      validator: (v) => ['range', 'endOnly'].includes(v),
    },
  },
  data () {
    return {
      menuPeriod: false,
      menuStartTime: false,
      menuEndTime: false,
      dateRange: [],
      singleDate: '',
      resetTime: '23:59',
      startTime: '00:00',
      endTime: '23:59',
    };
  },
  created () {
    this.startTime = this.nowHm();
  },
  computed: {
    canApplyEndOnly () {
      return !!(this.singleDate && this.resetTime);
    },
    canApplyPeriod () {
      const range = this.sortedDateRange;
      if (!(range[0] && range[1] && this.startTime && this.endTime)) return false;
      if (this.isPeriodStartToday && this.isHmBefore(this.startTime, this.minStartTime)) {
        return false;
      }
      return true;
    },
    periodStartYmd () {
      const range = this.sortedDateRange;
      if (range[0]) return range[0];
      const raw = Array.isArray(this.dateRange) ? this.dateRange.filter(Boolean) : [];
      if (!raw.length) return '';
      return [...raw].sort()[0];
    },
    isPeriodStartToday () {
      return this.periodStartYmd === this.todayYmd;
    },
    minStartTime () {
      return this.isPeriodStartToday ? this.nowHm() : undefined;
    },
    sortedDateRange () {
      const range = Array.isArray(this.dateRange) ? [...this.dateRange] : [];
      if (range.length < 2) return range;
      return range[0] <= range[1] ? range : [range[1], range[0]];
    },
    todayYmd () {
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, '0');
      const d = String(now.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },
    periodText () {
      const start = this.value && this.value.startDate ? this.value.startDate : '';
      const end = this.value && this.value.endDate ? this.value.endDate : '';
      if (this.variant === 'endOnly') {
        if (!end) return '';
        return String(end).replace('T', ' ').trim();
      }
      if (start && end) {
        return `${String(start).replace('T', ' ').trim()} — ${String(end).replace('T', ' ').trim()}`;
      }
      if (start) return `${String(start).replace('T', ' ').trim()} — —`;
      return '';
    },
  },
  watch: {
    menuPeriod (open) {
      if (open) this.initFromValue();
    },
    dateRange: {
      deep: true,
      handler () {
        this.ensureStartTimeNotPast();
      },
    },
    'value.useSchedule' (enabled) {
      if (!enabled) {
        this.dateRange = [];
        this.singleDate = '';
        this.resetTime = '23:59';
        this.startTime = this.nowHm();
        this.endTime = '23:59';
        this.menuPeriod = false;
      }
    },
  },
  methods: {
    onToggleSchedule (enabled) {
      if (!enabled) {
        this.$emit('input', {
          useSchedule: false,
          startDate: '',
          endDate: '',
        });
      } else {
        this.$emit('input', {
          ...this.value,
          useSchedule: true,
        });
      }
    },
    initFromValue () {
      const start = this.value && this.value.startDate ? this.value.startDate : '';
      const end = this.value && this.value.endDate ? this.value.endDate : '';

      const toYmd = (v) => {
        if (!v) return '';
        if (v instanceof Date) {
          const y = v.getFullYear();
          const m = String(v.getMonth() + 1).padStart(2, '0');
          const d = String(v.getDate()).padStart(2, '0');
          return `${y}-${m}-${d}`;
        }
        if (typeof v === 'string') {
          const m = v.trim().match(/^(\d{4}-\d{2}-\d{2})/);
          if (m) return m[1];
        }
        const dt = new Date(v);
        if (Number.isNaN(dt.getTime())) return '';
        const y = dt.getFullYear();
        const m = String(dt.getMonth() + 1).padStart(2, '0');
        const d = String(dt.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
      };

      const parseHm = (v, fallback) => {
        if (!v) return fallback;
        const raw = String(v).trim();
        const m = raw.match(/^(\d{4}-\d{2}-\d{2})(?:[ T](\d{2}):(\d{2})(?::\d{2})?)?/);
        if (m && m[2] != null) return `${m[2]}:${m[3]}`;
        return fallback;
      };

      const startYmd = toYmd(start);
      const endYmd = toYmd(end);

      if (this.variant === 'endOnly') {
        const raw = end ? String(end).trim() : '';
        if (raw) {
          const m = raw.match(/^(\d{4}-\d{2}-\d{2})(?:[ T](\d{2}):(\d{2})(?::\d{2})?)?/);
          if (m) {
            this.singleDate = m[1];
            this.resetTime = m[2] != null ? `${m[2]}:${m[3]}` : '23:59';
          } else {
            this.singleDate = endYmd || '';
            this.resetTime = '23:59';
          }
        } else {
          this.singleDate = '';
          this.resetTime = '23:59';
        }
        return;
      }

      this.dateRange = [];
      if (startYmd) this.dateRange.push(startYmd);
      if (endYmd) this.dateRange.push(endYmd);
      this.startTime = parseHm(start, this.nowHm());
      this.endTime = parseHm(end, '23:59');
      this.ensureStartTimeNotPast();
    },
    isHmBefore (a, b) {
      if (!a || !b) return false;
      const [ah, am] = String(a).split(':').map(Number);
      const [bh, bm] = String(b).split(':').map(Number);
      return ah < bh || (ah === bh && am < bm);
    },
    ensureStartTimeNotPast () {
      if (!this.isPeriodStartToday) return;
      const min = this.nowHm();
      if (this.isHmBefore(this.startTime, min)) {
        this.startTime = min;
      }
    },
    onStartTimePicked () {
      this.ensureStartTimeNotPast();
      this.menuStartTime = false;
    },
    clearPeriodEndOnly () {
      this.singleDate = '';
      this.resetTime = '23:59';
      this.$emit('input', {
        ...this.value,
        useSchedule: true,
        startDate: '',
        endDate: '',
      });
    },
    applyPeriodEndOnly () {
      const ymd = this.singleDate || '';
      if (!ymd || !this.resetTime) return;
      const endDate = `${ymd} ${this.resetTime}:00`;
      this.$emit('input', {
        ...this.value,
        useSchedule: true,
        startDate: '',
        endDate,
      });
      this.menuPeriod = false;
    },
    nowHm () {
      const now = new Date();
      const h = String(now.getHours()).padStart(2, '0');
      const m = String(now.getMinutes()).padStart(2, '0');
      return `${h}:${m}`;
    },
    clearPeriod () {
      this.dateRange = [];
      this.startTime = this.nowHm();
      this.endTime = '23:59';
      this.$emit('input', {
        ...this.value,
        useSchedule: true,
        startDate: '',
        endDate: '',
      });
    },
    applyPeriod () {
      const range = this.sortedDateRange;
      const start = range[0] || '';
      const end = range[1] || '';
      if (!start || !end || !this.startTime || !this.endTime) return;

      if (start === this.todayYmd && this.isHmBefore(this.startTime, this.nowHm())) {
        if (typeof this.$flash_warning === 'function') {
          this.$flash_warning('Время начала не может быть в прошлом');
        }
        this.startTime = this.nowHm();
        return;
      }

      this.$emit('input', {
        ...this.value,
        useSchedule: true,
        startDate: `${start} ${this.startTime}:00`,
        endDate: `${end} ${this.endTime}:00`,
      });
      this.menuPeriod = false;
    },
  },
};
</script>

<style scoped>
.mass-schedule-fields__expand {
  margin-top: 2px;
}

.mass-schedule-fields__picker {
  width: 320px;
  max-width: 320px;
}

:deep(.mass-schedule-fields__menu-content) {
  min-width: 320px !important;
  width: 320px !important;
  max-width: 320px !important;
}

:deep(.mass-schedule-fields__menu-content--end-only) {
  overflow: hidden !important;
  contain: layout;
}

:deep(.mass-schedule-fields__menu-content--range) {
  overflow: hidden !important;
  contain: layout;
}

.mass-schedule-fields__range-menu {
  display: flex;
  flex-direction: column;
  max-height: min(90vh, 760px);
  background: var(--v-card-base, #fff);
}

.mass-schedule-fields__range-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.mass-schedule-fields__times {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.mass-schedule-fields__range-actions {
  flex-shrink: 0;
  padding: 12px 12px 16px;
  background: var(--v-card-base, #fff);
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.06);
}

.mass-schedule-fields__end-only-menu {
  display: flex;
  flex-direction: column;
  max-height: min(90vh, 720px);
  background: var(--v-card-base, #fff);
}

.mass-schedule-fields__end-only-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.mass-schedule-fields__time-picker {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.mass-schedule-fields__end-only-actions {
  flex-shrink: 0;
  padding: 12px 12px 16px;
  background: var(--v-card-base, #fff);
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.06);
}
</style>
